import { PropsWithChildren } from "react";
import { TooltipHost, TooltipOverflowMode } from "@fluentui/react/lib/Tooltip";
import { Stack } from "@fluentui/react/lib/Stack";
import { Text } from "@fluentui/react/lib/Text";

import { TargetLink } from "Components/Generic/TargetLink";
import { getName } from "Utils/Item";
import { isFalse } from "Utils/Boolean";
import { isNotNullOrWhiteSpace } from "Utils/String";
import { IResultCardProps } from "./IResultCardProps";
import { useResultCardStyles } from "./UseResultCardStyles";

export function ResultCard(props: PropsWithChildren<IResultCardProps>): JSX.Element {
  const { children, result } = props;
  const title = result?.[`@resultTitle`] ?? getName(result);
  const hasTargetUrl = isNotNullOrWhiteSpace(result[`@targetUrl`]);
  const badgeText = result[`@resultBadge`];
  const styles = useResultCardStyles();

  return (
    <Stack className={styles.root}>
      <Stack horizontal className={styles.titleWrap}>
        <Stack.Item grow className={styles.title}>
          <TooltipHost content={title} overflowMode={TooltipOverflowMode.Parent}>
            {hasTargetUrl
              ? (
                <Text variant="mediumPlus">
                  <TargetLink item={{ ...result, name: title }} />
                </Text>
              )
              : (
                <Text variant="mediumPlus">{title}</Text>
              )}
          </TooltipHost>
        </Stack.Item>
        {isFalse(result?.[`@isOrigin`])
          ? (
            <Stack.Item disableShrink align="end" className={styles.badge}>
              <TooltipHost content={badgeText} overflowMode={TooltipOverflowMode.Parent}>
                <Text variant="smallPlus">{badgeText}</Text>
              </TooltipHost>
            </Stack.Item>
          )
          : null}
      </Stack>
      <Stack.Item>{children}</Stack.Item>
    </Stack>
  );
}
